import { FC } from 'react'
import styled from 'styled-components'
import { ActivityFilter } from 'generated/graphql'
import BottomSelectedFilterList from './BottomSelectedFilterList'
import FilterSubmitButton from './FilterSubmitButton'

interface IFActivityFilterBottomProps {
  onSubmit: (filterBy: ActivityFilter) => void
  className?: string
  filterType: 'calender' | 'activity'
}

const ActivityFilterBottom: FC<IFActivityFilterBottomProps> = ({
  onSubmit,
  className,
  filterType,
}) => {
  return (
    <StyledWrapper className={className}>
      <BottomSelectedFilterList className="selected-filter-list" />
      <div className="submit-button-wrapper">
        <FilterSubmitButton onSubmit={onSubmit} filterType={filterType} />
      </div>
    </StyledWrapper>
  )
}

export default ActivityFilterBottom

const StyledWrapper = styled.div`
  width: 100%;
  padding: 15px 0;
  z-index: 2;

  .selected-filter-list {
    margin-bottom: 12px;
    padding: 0 20px;
  }

  .submit-button-wrapper {
    padding: 0 20px;
  }
`
